// Minimal Tabler-outline-style icon set — no icon package is installed in
// this app yet, so these are hand-drawn to match Tabler's stroke convention
// (24x24 viewBox, round caps/joins, 1.75 stroke) rather than pull a new dep.
import type { SVGProps } from "react";

function IconBase(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
  );
}

export function IconArrowLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M5 12h14" />
      <path d="M5 12l6 6" />
      <path d="M5 12l6 -6" />
    </IconBase>
  );
}

export function IconCalendarEvent(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="4" y="5" width="16" height="16" rx="2" />
      <path d="M4 10h16" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M9 15h1" />
      <path d="M14 15h1" />
    </IconBase>
  );
}

export function IconUsers(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20v-1a5 5 0 0 1 5 -5h2a5 5 0 0 1 5 5v1" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M21 20v-1a4 4 0 0 0 -3 -3.87" />
    </IconBase>
  );
}

export function IconMessage(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8l-4 4v-4h-2a2 2 0 0 1 -2 -2z" />
    </IconBase>
  );
}

export function IconFiles(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M9 3h6l4 4v10a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2z" />
      <path d="M9 8h4" />
      <path d="M9 12h6" />
      <path d="M9 16h6" />
    </IconBase>
  );
}

export function IconDeviceMobile(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="7" y="3" width="10" height="18" rx="1.5" />
      <path d="M11 4.5h2" />
      <path d="M12 17.5v.01" />
    </IconBase>
  );
}

export function IconBuildingBank(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M4 10l8 -5l8 5" />
      <path d="M4 21h16" />
      <path d="M5 10v9" />
      <path d="M19 10v9" />
      <path d="M9 13v5" />
      <path d="M15 13v5" />
    </IconBase>
  );
}

export function IconCreditCard(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 15h2" />
    </IconBase>
  );
}

export function IconDots(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="5" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
    </IconBase>
  );
}

export function IconLock(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
    </IconBase>
  );
}

export function IconAlertTriangle(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M12 3.5l9.5 16.5h-19z" />
      <path d="M12 10v3.5" />
      <path d="M12 17v.01" />
    </IconBase>
  );
}

export function IconClock(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 3" />
    </IconBase>
  );
}

export function IconX(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M18 6l-12 12" />
      <path d="M6 6l12 12" />
    </IconBase>
  );
}

export function IconCamera(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M4 8a2 2 0 0 1 2 -2h1l1.5 -2h7l1.5 2h1a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
      <circle cx="12" cy="13" r="3.5" />
    </IconBase>
  );
}

export function IconActivity(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M3 12h4l3 8l4 -16l3 8h4" />
    </IconBase>
  );
}

export function IconCash(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M6.5 6v.01" />
      <path d="M17.5 18v-.01" />
    </IconBase>
  );
}

export function IconUserCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M3 20v-1a5 5 0 0 1 5 -5h2a5 5 0 0 1 4 2" />
      <path d="M16 16l1.5 1.5l3 -3" />
    </IconBase>
  );
}

export function IconBook(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M5 4.5A2.5 2.5 0 0 1 7.5 2H19v17H7.5A2.5 2.5 0 0 0 5 21.5v-17z" />
      <path d="M19 19H7.5A2.5 2.5 0 0 0 5 21.5" />
    </IconBase>
  );
}

export function IconCertificate(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="4" y="4" width="16" height="12" rx="2" />
      <circle cx="12" cy="10" r="2.25" />
      <path d="M9.5 16.5l-1.5 4l4 -1.5l4 1.5l-1.5 -4" />
    </IconBase>
  );
}

export function IconExternalLink(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M11 4H6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-5" />
      <path d="M20 3.5v5.5h-5.5" />
      <path d="M10 14l10 -10" />
    </IconBase>
  );
}

export function IconMapPin(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M12 21s-7 -6.1 -7 -11.5a7 7 0 0 1 14 0c0 5.4 -7 11.5 -7 11.5z" />
      <circle cx="12" cy="9.5" r="2.25" />
    </IconBase>
  );
}

export function IconClipboardCheck(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0.5H9z" />
      <path d="M9 13l2 2l4 -4" />
    </IconBase>
  );
}

export function IconAward(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="8.5" r="5" />
      <path d="M9 12.5l-1.5 7l4.5 -2.5l4.5 2.5l-1.5 -7" />
    </IconBase>
  );
}
